@if (hasAnythingToShow()) {
  <div class="fpu">
    @if (usedPortalRows().length) {
      <div class="fpu__row">
        <span class="fpu__label" i18n>Za oglaševanje uporabljajo:</span>
        <span class="fpu__logos">
          @for (row of usedPortalRows(); track row.type) {
            @if (row.logoSrc) {
              <img class="fpu__logo" [src]="row.logoSrc" [alt]="row.name" [title]="row.name" />
            } @else {
              <span class="fpu__chip" [title]="row.name">{{ row.name }}</span>
            }
          }
        </span>
      </div>
    }
    @for (row of excludedPortalRows(); track row.type) {
      <div class="fpu__row fpu__row--excluded">
        @if (row.logoSrc) {
          <img class="fpu__logo fpu__logo--muted" [src]="row.logoSrc" [alt]="row.name" [title]="row.name" />
        }
        <span class="fpu__excluded-text" i18n>Tega ne uporablja {{ row.name }}</span>
      </div>
    }
  </div>
}
